import React from 'react';
import AppLayout from '../components-app/AppLayout';
import u from '../utilities/Utilities';
import {Step,Databox} from '../components-static/Common';
import {TextButton} from '../components-static/Input';

export default class Download extends React.Component{

    state={
        error:"",
        step:0
    };

    filename = this.props.match.params.filename;

    filestamp = this.props.match.params.filestamp;

    scrollAnchor=u.getKey();

    componentDidMount=()=>{
        if(this.filename && this.filestamp){
            this.downloadFile();
            this.setState({step:1,error:""});
        }
        else {
            this.setState({step:2,error:"File not found"});
        }
    }

    downloadFile=()=>{
        u.download(this.filename,this.filestamp,()=>{},(error)=>{this.setState({step:2,error:error})});
    }

    render(){
        return (
            <AppLayout requiredPermission="none" title="Download" url="/download-file">
                <div style={{padding:"100px 0",textAlign:"center"}}>
                    <Step active={this.state.step == 0}>
                        <div>Searching for file...</div>
                    </Step>
                    <Step active={this.state.step == 1}>
                        <h1 className="text-emphasis">File Download Started</h1>
                        <div>Note: If your download does not start after 5 seconds, please <TextButton onClick={this.downloadFile} style={{margin:0}}>click here</TextButton> to download</div>
                    </Step>
                    <Step active={this.state.step == 2}>
                        <h1 className="text-negative">{this.state.error}</h1>
                        <div>Note: If this problem persists, please contact your system administrator</div>
                    </Step>
                </div>
            </AppLayout>
        )
    }
}